/**
 * YAM-209 – Product tracking enrichment & wishlist event.
 * Populates standard GA4 item parameters on Elevar pre-checkout events via window.ElevarTransformFn
 * and pushes dl_add_to_wishlist on Swym "addedToWishlist".
 * Product data is rendered by snippets/analytics-product-data.liquid.
 */
(function () {
  'use strict';

  // Elevar event -> path of the products array inside `ecommerce`
  var PRODUCT_PATHS = {
    dl_view_item_list: ['impressions'],
    dl_view_item: ['detail', 'products'],
    dl_add_to_cart: ['add', 'products'],
  };

  var cache = {};

  function getProductData(productId) {
    var id = String(productId || '');
    if (!id) return null;
    if (cache[id]) return cache[id];

    var el = document.querySelector('script[data-ym-analytics-product="' + id + '"]');
    if (!el) return null;

    try {
      cache[id] = JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
    return cache[id];
  }

  // Standard GA4 item params: category -> item_category, item_category2, item_category3.
  // Colour/size are already in Elevar's `variant` (-> item_variant), brand in `brand` (-> item_brand).
  function buildAttributes(productId, variantId) {
    var data = getProductData(productId);
    if (!data) return null;

    var variant = (data.variants || {})[String(variantId || '')] || {};
    var attributes = {
      // No standard GA4 param for colour/size: custom params, must be mapped in GTM / Elevar S2S
      item_color: variant.color || '',
      item_size: variant.size || '',
      color: variant.color || '',
      size: variant.size || '',
      gender: data.gender || '',
      business_line: data.business_line || '',
      year: data.year || '',
      season: data.season || '',
      item_product_id: String(productId),
      item_category2: data.category2 || '',
      item_category3: data.category3 || '',
    };
    // Override Elevar's `category` (string -> string) only when we have a value
    if (data.category) attributes.category = data.category;
    return attributes;
  }

  function enrichProduct(product) {
    var attributes = buildAttributes(product.product_id, product.variant_id);
    return attributes ? Object.assign({}, product, attributes) : product;
  }

  // Elevar requires: always return a value, never mutate the input, never drop properties.
  function enrichEvent(event) {
    var path = event && PRODUCT_PATHS[event.event];
    if (!path || !event.ecommerce) return event;

    var ecommerce = event.ecommerce;

    if (path.length === 1) {
      var list = ecommerce[path[0]];
      if (!Array.isArray(list)) return event;
      var patchedRoot = {};
      patchedRoot[path[0]] = list.map(enrichProduct);
      return Object.assign({}, event, { ecommerce: Object.assign({}, ecommerce, patchedRoot) });
    }

    var node = ecommerce[path[0]];
    if (!node || !Array.isArray(node[path[1]])) return event;

    var patchedNode = {};
    patchedNode[path[1]] = node[path[1]].map(enrichProduct);
    var patchedEcommerce = {};
    patchedEcommerce[path[0]] = Object.assign({}, node, patchedNode);
    return Object.assign({}, event, { ecommerce: Object.assign({}, ecommerce, patchedEcommerce) });
  }

  var previousTransform = window.ElevarTransformFn;
  window.ElevarTransformFn = function (event) {
    var base = typeof previousTransform === 'function' ? previousTransform(event) : event;
    try {
      return enrichEvent(base);
    } catch (e) {
      return base;
    }
  };

  function pushAddToWishlist(swymData) {
    var productId = String(swymData.empi || '');
    var variantId = String(swymData.epi || '');
    if (!productId || !variantId) return;

    var data = getProductData(productId) || {};
    var variant = (data.variants || {})[variantId] || {};
    var rawPrice = variant.price != null ? variant.price : swymData.pr;
    var price = rawPrice != null && rawPrice !== '' && !isNaN(Number(rawPrice)) ? Number(rawPrice).toFixed(2) : '';

    // Same shape as Elevar's built-in products; `id` (-> item_id) = variant ID, as in the feed g:id
    var product = Object.assign(
      {
        id: variantId,
        product_id: productId,
        variant_id: variantId,
        sku: variant.sku || swymData.sku || '',
        name: data.title || swymData.dt || '',
        brand: data.vendor || swymData.bt || '',
        category: '',
        variant: variant.title || swymData.vi || '',
        price: price,
        quantity: '1',
        url: swymData.du || '',
        image: swymData.iu || '',
      },
      buildAttributes(productId, variantId) || {}
    );

    window.ElevarDataLayer = window.ElevarDataLayer || [];
    window.ElevarDataLayer.push({
      event: 'dl_add_to_wishlist',
      ecommerce: {
        currencyCode: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
        value: product.price,
        products: [product],
      },
    });
  }

  function onSwymReady(swat) {
    var tracker = window.SwymTracker;
    var eventName = tracker && tracker.JSEvents && tracker.JSEvents.addedToWishlist;
    if (!eventName || !swat || !swat.evtLayer) return;

    swat.evtLayer.addEventListener(eventName, function (e) {
      try {
        pushAddToWishlist((e && e.detail && e.detail.d) || {});
      } catch (err) {
        // Tracking must never break the wishlist UX
      }
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(onSwymReady);
})();
